<template>
  <Popper placement="left">
    <button
      class="cabinet__tbody-btn"
      aria-describedby="tooltip"
    />
    <template #content>
      <ul class="tooltip__list tooltip">
        <li
          v-if="isExist('notice')"
          class="tooltip__list-item"
        >
          <router-link
            class="tooltip__list-item-text"
            :to="{ name: 'Lot', params: { lotID: item.id } }"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--show" />
            Просмотр извещения
          </router-link>
        </li>
        <li
          v-if="isExist('favorite')"
          class="tooltip__list-item tooltip__list-favourites"
          @click="favoriteToggle"
        >
          <p
            v-if="!isFavorite"
            class="tooltip__list-item-text tooltip__list-favourites--add"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--star" />
            Добавить в Избранные
          </p>
          <p
            v-else
            class="tooltip__list-item-text tooltip__list-item-text--green tooltip__list-favourites--remove"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--star" />
            Удалить из избранных
          </p>
        </li>
        <li
          v-if="isExist('badding')"
          class="tooltip__list-item"
        >
          <a
            class="tooltip__list-item-text"
            href="#"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--notification" />
            Уведомить о начале торгов
          </a>
        </li>
        <li
          v-if="isExist('apply')"
          class="tooltip__list-item"
        >
          <router-link
            class="tooltip__list-item-text"
            :to="{ name: 'Request', params: { lotID: item.id } }"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--paper-plus" />
            Подать заявку
          </router-link>
        </li>
        <li
          v-if="isExist('explanation')"
          class="tooltip__list-item"
        >
          <a
            class="tooltip__list-item-text"
            href="#"
            @click.prevent="goToClarification"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--message" />
            Подать запрос на&nbsp;разъяснения
          </a>
        </li>
        <li
          v-if="isExist('archive', item)"
          class="tooltip__list-item"
        >
          <div
            class="tooltip__list-item-text"
            @click="downloadArchiveLotOffers(item)"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--paper-download" />
            Скачать результаты
          </div>
        </li>
        <li
          v-if="isExist('history')"
          class="tooltip__list-item"
        >
          <router-link
            :to="{ name: 'History', params: {lotID: item.id} }"
            class="tooltip__list-item-text"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--time-circle" />
            История изменений
          </router-link>
        </li>
      </ul>
    </template>
  </Popper>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Popper from 'vue3-popper';
import api from '@/api';
import FileDownload from 'js-file-download';

const ACCESSES = {
  actual: ['notice', 'favorite', 'apply', 'explanation', 'history'],
  favorite: ['notice', 'favorite', 'apply', 'explanation', 'history'],
  my: ['notice', 'favorite', 'badding'],
  planned: ['notice', 'favorite', 'badding'],
  archive: ['notice', 'history'],
};

export default {
  name: 'PurchasesTableTooltip',
  components: {
    Popper,
  },
  props: ['item'],
  data() {
    return {
      isFavorite: false,
    };
  },
  computed: {
    ...mapState({
      filterType: (state) => state.appService.filterType,
      roles: (state) => state.user.roles,
    }),
  },
  watch: {
    'item.favorite': {
      handler() {
        this.isFavorite = this.item.favorite;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('lots', ['toggleFavoriteLot']),
    isExist(property, item = null) {
      const page = this.filterType;
      const rolesName = this.roles.map((role) => role.name);
      if (rolesName.includes('supplier') && ACCESSES[page] !== undefined) {
        return ACCESSES[page].includes(property);
      }
      if (rolesName.includes('customer') && property === 'archive' && this.isArchiveLotWithOffers(item)) {
        return true;
      }
      return property === 'notice';
    },
    async favoriteToggle() {
      this.isFavorite = !this.isFavorite;
      const result = await this.toggleFavoriteLot(this.item.id);
      if (!result) {
        this.isFavorite = !this.isFavorite;
      }
    },
    isArchiveLotWithOffers(item) {
      if (!item || !item.status) {
        return false;
      }
      return item.status === 'Закрыта' && item.offer && item.offer.suppliers;
    },
    goToClarification() {
      if (this.item.clarificationId) {
        this.$router.push({ name: 'ClarificationRequest', params: { id: this.item.clarificationId } });
      } else {
        this.$router.push({
          name: 'ClarificationRequestCreate',
          params: { lotId: this.item.id },
        });
      }
    },
    async downloadArchiveLotOffers(item) {
      const getFileName = (response) => {
        let name = `Файлы_предложений_по_лоту_${item.documentNumber}.zip`;

        try {
          const file = String(response.headers['content-disposition'])
            .split('filename=')[1];
          name = decodeURIComponent(file);
        } catch (e) {
          console.error(e);
        }
        return name;
      };

      try {
        const response = await api.lots.customer.downloadLotArchive({ id: item.id });
        FileDownload(response.data, getFileName(response));
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped></style>
